import React from 'react'
import {Card, Drawer, Form, Icon, notification, Button, Tooltip, Input, Row, Col} from 'antd'
import _ from 'lodash'
import {connect} from 'react-redux'
import Request from '../../request'
import Payment from '../../components/_utils/payment'
import ListPaymentFollowUps from '../../components/_utils/listPaymentFollowUp'
import LatestPaymentFollowup from '../../components/_utils/latestPaymentFollowup'
import LatestFollowUp from '../../components/_utils/latestFollowup'
import {BackgroundClass, TableComp} from 'sz-react-utils'
import moment from 'moment'

let inquiryObj = {};
let studentObj = {};

class PendingConsultancyFollowups extends React.Component {
    state = {
        visible: false,
        allFollowups: [],
        allCounsellor: [],
        total: 0,
        showFollowUp: false,
        showPayNow: false
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            let data = await Request.getPendingConsultancyFollowups({
                ...params
            });
            
            if(data.total > 0) {
                this.setState({visible: true});
            }
            if(data.total == 0) {
                this.setState({visible: false});
            }
            this.setState({total: data.total})
            resolve(data)
        })
    }
    async componentDidMount() {
        this.apiRequest();
        this.table = React.createRef()        
    }
    onClose = () => {
        this.setState({
            visible: false
        })
        setTimeout(() => {
            // this.props.onClose()
        }, 400)
    }

    openPayNow = record => {
        inquiryObj = {
            record: record,
            registrationDesk: record.registrationDesk,
            _id: record._id
        }
        this.setState({showPayNow: true})
    }

    closePayNow = () => {
        this.setState({showPayNow: false})
        this.table.current.reload()
    }
    closeFollowUp = () => {
        this.setState({showFollowUp: false})
        this.table.current.reload()
    }
    openFollowUps = (record) => {
        studentObj = {
          arr: record.followUp,
          name: record.studentName,
          rating: record.counsellingDesk.rating,
          subRating: record.counsellingDesk.subRating,
          _id: record._id,
        };
        this.setState({ showFollowUp: true });
    };
    followUpExtendedDate = (followUp) => {
        if(followUp && followUp.followUpDate){
          return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
        }
    }

    render() {
        const { 
            total
        } = this.state;
        
        const columns = [
            {
                title: "Action",
                key: "operation",
                dataindex: "operation",
                width: 60,
                render: (text, record) => (
                  <React.Fragment>
                    <Tooltip title="FollowUps">
                      <Button
                        size={"small"}
                        shape="circle"
                        onClick={() => this.openFollowUps(record)}
                        icon="calendar"
                      />
                    </Tooltip>&nbsp;
                  </React.Fragment>
                ),
            },
            {
                title: 'ID',
                key: 'id',
                dataIndex: 'id',
                searchTextName: 'id',
                sorter: true,
                width: 80,
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                searchTextName: 'studentName',
                width: 200,
                render: (text, record) => (
                    <div>
                        <React.Fragment>
                        <div
                            className={
                            this.followUpExtendedDate(record.followUp ? record.followUp : '')? '' : ''
                            }
                        >
                            <Tooltip title="Click To Edit Details">
                                <a target={'_blank'}
                                   href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                >{text}</a>
                            </Tooltip>
                            <div>{record.mobile}</div>

                            <div>{record.emailId}</div>
                        </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Payment Details',
                key: 'registrationDesk',
                dataIndex: 'registrationDesk',
                width: 120,
                filterMultiple: false,
                render: (item, record) => {
                    const bgBalance = {background:'red', color:'white', padding:'10px'};
                    return (
                        <div style={ item.balance ? bgBalance : {}}>
                            {item.total ? <React.Fragment>Total : {item.total}<br/></React.Fragment> : ''}
                            {item.paid ? <React.Fragment>Paid : {item.paid}<br/></React.Fragment> : ''}
                            {item.balance ? <React.Fragment>Balance : {item.balance}<br/></React.Fragment> : ''}
                            {item.balance ? <React.Fragment>
                                <Button
                                    onClick={() => this.openPayNow(record)}
                                >Pay Now</Button>
                            </React.Fragment> : ''}
                        </div>
                    )
                }
            },
            {
                title: 'DOB ',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Counsellor',
                width: 150,
                key: 'counsellorId',
                render: (text, record) => {
                    return (
                        <div>{record.counsellorId ? record.counsellorId.name : ''}</div>
                    )
                }
            },
            {
                title: 'Follow Up',
                key: 'followUp',
                width: 180,
                dataIndex: 'followUp',
                searchTextName: 'followUp',
                render: (text, record) => {
                    return <LatestFollowUp info={text} />
                }
            },
            {
                title: 'Payment Follow Up',
                key: 'paymentFollowUp.followUpDate',
                width: 200,
                dataIndex: 'paymentFollowUp',
                render: (text, record) => {
                    return <LatestPaymentFollowup info={text}/>
                }
            },
            {
                title: 'At Stage',
                key: 'atStage',
                width: 150,
                filters: [
                    {value: 'Application Desk', text: 'Application Desk'},
                    {value: 'Visa Desk', text: 'Visa Desk'},
                    {value: 'Claim Desk', text: 'Claim Desk'}
                ],
                render: (val, record) => {
                    return (
                        <div>{record.atLevel}</div>
                    )
                }
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        {'Pending Consultancy Follow Ups:-'} {total}
                        <a onClick={this.onClose} style={{float: 'right', color: 'black'}}>
                            <Icon type={'close'}/>
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                {this.state.showFollowUp ? (
                    <ListPaymentFollowUps studentObj={studentObj} onClose={this.closeFollowUp}/>
                ) : null}

                {this.state.showPayNow ? (
                    <Payment inquiryObj={inquiryObj} onClose={this.closePayNow}/>
                ) : null}
                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        id={'submitfee'}
                        get che
                        apiRequest={this.apiRequest}
                        extraProps={{scroll: {x: 1000}}}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}
  
const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PendingConsultancyFollowups)